import { Typography } from '@mui/material'
import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import BGDesktop from '../../asserts/Ab.png';
import BGMobile from '../../asserts/Ab_m.png'
import CheckIcon from '@mui/icons-material/Check';
import Mission from '../../asserts/mission.webp'
import Vision from '../../asserts/mission.png'
import Update from '../../asserts/rb_15449.png'
import Teacher from '../../asserts/13404833_5211205.png'
import PG from '../../asserts/PG TRB physycs.png';
import UG from '../../asserts/PG TRB physycs – 1.png';
import KT from '../../asserts/KATTAYA TAMILPADA THERVU.png';
import UGC from '../../asserts/UGC NET.png'
import Footer from '../footer';
import { useState,useEffect } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';


export default function AboutUs() {
  const [bgImage, setBgImage] = useState(BGDesktop);

  useEffect(() => {
    const updateBackground = () => {
      if (window.innerWidth <= 768) {
        setBgImage(BGMobile);
      } else {
        setBgImage(BGDesktop);
      }
    };

    updateBackground(); // Set initial background
    window.addEventListener("resize", updateBackground);

    return () => {
      window.removeEventListener("resize", updateBackground);
    };
  }, []);


  // const MainContainer = {
  //   background: `url(${bgImage})`,
  //   height: "50vh",
  //   backgroundSize: "cover",
  //   backgroundPosition: "center",
  //   backgroundRepeat:'no-repeat',
  // };
  const MainContainer = {
    background: `url(${bgImage})`,
    height: "50vh",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    overflowX: "hidden", // Prevent horizontal scrolling
};

  const MainCol={
    display:"flex",
    backgroundColor:"rgba(255, 255, 255, 0.301)",
    height:"70vh",
    width:"98vw",
    alignItems:"center"
  }
  const MainDiv={
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    width:"99vw",
  }
  const ColStyle={
    display:"flex",
    justifyContent:"center",
    alignItems:"center"
  }
  const imgHeight = window.innerWidth <= 768 ? "150px" : "200px";
  return (
    <div>
      <Container fluid style={MainContainer}>
        <Row>
          <Col style={MainCol}>
            <div style={MainDiv}>
           
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid style={{marginTop:"30px"}}>
        <Row>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} style={ColStyle}>
            <div>
              <img src={Teacher} height="200px"/>
            </div>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6} style={ColStyle}>
          <div style={{marginTop:"40px"}}>
              <Typography variant='h5' style={{paddingBottom:"20px",fontWeight:600}}>SPEED ACADEMY TEACHER</Typography>
              <div style={{width:"90%"}}>
              <ul style={{textAlign:"justify",listStyleType:"none"}}>
                <li>
                <CheckCircleOutlineIcon style={{color:"#179ecb"}}/>&nbsp;2 years Assistant professor in physics</li>
                <li>
                <CheckCircleOutlineIcon style={{color:"#179ecb"}}/>&nbsp;12 years experience in Higher secondary level physics</li>
                <li>
                <CheckCircleOutlineIcon style={{color:"#179ecb"}}/>&nbsp;TNSET complete</li> 
              </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Container  style={{marginTop:"30px"}}>
        <Row>
          <Col xs={{order:2}} sm={{order:2}}  lg={{order:1}} xl={{order:1}} md={{ order: 1 }} style={ColStyle}>
            <div>
              <Typography variant='h5' style={{paddingBottom:"20px",fontWeight:600}}>PG-TRB PHYSICS </Typography>
              <ul style={{textAlign:"justify",listStyleType:"none"}}>
                <li><CheckCircleOutlineIcon style={{color:"#179ecb"}}/> தமிழக அரசுப்பள்ளிகள் பயிலும் 11 மற்றும் 12 வகுப்பு மாணவர்களுக்கு கற்பிப்பதற்கான ஆசிரியர்ளை தேர்ந்தெடுப்பதன் பொருட்டு தமிழ்நாடு அரசு ஆசிரியர் தேர்வு வாரியம் மூலமாக தேர்வினை காலிப்பணியிடங்களுக்கேற்ப நடத்தி ஆசிரியர்களை நியமிக்கிறது. </li>
                <li><CheckCircleOutlineIcon style={{color:"#179ecb"}}/> இயற்பியல் பாடத்தில் முதுகலைப் பட்டமும் இளங்கலைக் கல்வியியலும் (M.A.,M.Ed,)(MSC) படித்து முடித்தவர்கள் இத்தேர்வினை எழுதும் தகுதி உடையவர்கள் ஆவர். இத்தேர்வில் கொள்குறி வகையில் (MCQ) 150 வினாக்கள் கொண்டது முதன்மைப்பாடத்தில் 110 கல்வியியல் மற்றும் உளவியல் பாடத்தில் -30, பொது அறிவு - 10 என 150 மதிப்பெண்கள் கொண்டதாகும். </li>
              </ul>
              
             
            </div>
          </Col>
          <Col  xs={12} sm={12} md={6}  lg={{order:2}} xl={{order:2}} style={ColStyle}>
          <div>
          <img src={PG}  height={imgHeight}/>
          </div>
          </Col>
        </Row>
      </Container>
      <Container fluid style={{backgroundColor:"#ecf7fb",marginTop:"30px"}}>
        <Row>
        

<Col xs={12} sm={12} md={6} lg={6} xl={6} style={ColStyle}>
  <div>
    <img src={UG} height={imgHeight} />
  </div>
</Col>

          <Col xs={12} sm={12} md={6} lg={6} xl={6} style={ColStyle}>
          <div style={{marginTop:"40px"}}>
              <Typography variant='h5' style={{paddingBottom:"20px",fontWeight:600}}>UG-TRB - PHYSICS</Typography>
              <div style={{width:"90%"}}>
              <ul style={{textAlign:"justify",listStyleType:"none"}}>
                <li><CheckCircleOutlineIcon style={{color:"#179ecb"}}/>&nbsp;தமிழ்நாடு அரசு பள்ளிளியில் 6-10 வகுப்புகள் வரை அறிவியல் கற்பிப்பதற்காக ஆசிரியர் தகுதித் தேர்வில் (TNTET-Paper-2) தேர்ச்சிபெற்றவர்ளை பட்டதாரி ஆசிரியர்களாக நியமனம் செய்யும் பொருட்டு ஆசிரியர் தேர்வு வாரியம் மூலம் UG-TRB நியமனத்தேர்வு நடத்துகிறது.</li>
                  <li><CheckCircleOutlineIcon style={{color:"#179ecb"}}/>&nbsp;இதில் தேர்வாகும் பட்டதாரிகள் இளங்கலை ஆசிரியர்களாகவும்(BT ASSISTANT), வட்டார வளமைய அலுவலராகவும் (BRTE) நியமிக்கப்படுவர்
                  </li>
                
              </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
     
      <Footer/>
    </div>
  )
}
